import { Box, Container } from "src/components/MuiGenerals";
import TableTab from "src/components/TableTab";
import PageConfigProvider, {
  usePageConfigProviderContext,
} from "src/features/PageConfigProvider";
import { DivideLine } from "src/utils/HelperComp";
import { customSx } from "src/utils/styling";
import useRenderFilters from "./hooks/useRenderFilters";
import useTableColumns from "./hooks/useTableColumns";
import useTableRows from "./hooks/useTableRows";
import { GetListRes } from "./types/GetListRes";

const ViewFilterTable = () => {
  const { list } = usePageConfigProviderContext<unknown, GetListRes>();

  const { renderFields } = useRenderFilters();
  const { columns, renderDialogInTableRow } = useTableColumns();
  const { rows } = useTableRows({ apiList: list });

  return (
    <>
      {renderDialogInTableRow()}
      <Box sx={customSx.layoutBox}>
        <Container disableGutters maxWidth={false}>
          <Box sx={customSx.gridFilter} className="gridFilter">
            {renderFields()}
          </Box>
          <PageConfigProvider.SearchAndResetBox />
        </Container>
        <DivideLine />
        <Container
          style={customSx.datagridContainer}
          maxWidth={false}
          disableGutters>
          <TableTab>
            <PageConfigProvider.DataGrid columns={columns} rows={rows} />
          </TableTab>
        </Container>
      </Box>
    </>
  );
};

export default ViewFilterTable;
